import { Component } from '@angular/core';
import{InvoiceListComponent}from'../../../../components/admin-dashboard-component/invoice-list-component/invoice-list-component';

@Component({
  selector: 'app-invoice-list',
  imports: [InvoiceListComponent],
  templateUrl: './invoice-list.html',
  styleUrl: './invoice-list.scss',
})
export class InvoiceList {

}
